import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ContactPage } from './pages/ContactPage';
import { ServicesPage } from './pages/ServicesPage';
import { AboutPage } from './pages/AboutPage';
import { FAQsPage } from './pages/FAQsPage';
import { CancellationPolicyPage } from './pages/CancellationPolicyPage';
import { RefundPolicyPage } from './pages/RefundPolicyPage';
import { PrivacyCookiePolicyPage } from './pages/PrivacyCookiePolicyPage';
import { TermsConditionsPage } from './pages/TermsConditionsPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/contact" element={<ContactPage data-id="element-5" />} data-id="element-4" />
        <Route path="/services" element={<ServicesPage data-id="element-7" />} data-id="element-6" />
        <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
        <Route path="/faqs" element={<FAQsPage data-id="element-11" />} data-id="element-10" />
        <Route path="/cancellation-policy" element={<CancellationPolicyPage data-id="element-13" />} data-id="element-12" />
        <Route path="/refund-policy" element={<RefundPolicyPage data-id="element-15" />} data-id="element-14" />
        <Route path="/privacy-cookie-policy" element={<PrivacyCookiePolicyPage data-id="element-17" />} data-id="element-16" />
        <Route path="/terms-conditions" element={<TermsConditionsPage data-id="element-19" />} data-id="element-18" />
      </Routes>
    </Router>;
}